<template>
    <div class="exp-temp-dialog">
        <el-dialog title="报告模版" :visible.sync="open" fullscreen :modal="false">
            <template>
                <fm-making-form 
                    ref="makingform" 
                    style="height: 580px;" 
                    preview
                    clearable
                    :basic-fields="baseArray"
                    :advance-fields="seniorArray"
                    :layout-fields="[]"
                    :isToken="token"
                    :baseUrl="baseUrl"
                    :custom-config="customConfig"
                >
                    <!-- 表头自定义 -->
                    <template slot="textbox">
                        <el-input style="width:90%" placeholder="请输入模版名称" v-model="formData.name" size="mini" @change="templateNameChange"></el-input>
                    </template>
                    <template slot="action">  
                        <!-- upload导入 -->
                        <!-- generate-json生成代码 -->
                        <!-- preview 预览 -->
                        <!-- clearable  清空 -->
                        <el-button type="text" icon="el-icon-connection" @click="importSubject">导入题目</el-button>
                        <el-button type="text" icon="el-icon-document-checked" @click="handSave">保存模版</el-button>
                    </template>
                </fm-making-form>
            </template>
            <el-dialog width="50%" title="导入题目" :visible.sync="importOpen" append-to-body>
                <el-row>
                    <el-col :span="24">
                        <el-cascader class="dialog-cascader" v-model="expUid" placeholder="请选择实验项目"
                            :options="expList" :props="{ value: 'uid', label: 'name',}" clearable filterable style="width:50%" @change="handleChange"></el-cascader>
                    </el-col>
                </el-row>
                <el-table :data="tableData" ref="titleTable" style="width: 100%;margin:20px 0;" @selection-change="handleSelectionChange" row-key="uid">
                    <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
                    <el-table-column type="index" label="序号"></el-table-column>
                    <el-table-column prop="title" label="题目"></el-table-column>
                    <el-table-column prop="score" label="分数" width="80px"></el-table-column>
                </el-table>
                <el-pagination small  layout="prev, pager, next" hide-on-single-page :total="page.total" :current-page="page.page" :page-size="page.limit" :pager-count="page.pagerCount" @current-change="handPageChange"></el-pagination>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="importOpen = false">取 消</el-button>
                    <el-button type="primary" @click="submitTitle">确 定</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>
<script>
import { duplicateCheck } from "@/api/lab/experimentreportmould"
import { mapGetters }  from 'vuex'
import { baseUrl, staticUrl } from "@/config/env";
import { selectExpList } from '@/api/exp/experiment'
import { getExpExperimentQuery } from '@/api/exp/experiment-report'
export default {
    data(){
        return {
            expUid:[],
            expList: [],
            multipleSelection: [],  //多选框组
            tableData:[],
            importOpen:false,
            open: false,
            baseArray:['radio','checkbox'],
            seniorArray:['editor','textarea'],
            dataJson:{},
            formData:{
                name:'',
            },
            expPage:{
                page:1,
                limit:6,
                total:0
            },
            page:{
                page:1,
                limit:5,
                total:0
            },
            baseUrl:''
        }
    },
    props:{
        jsonData:{
            type: Object,
            default: () => {}
        }
    },
    computed:{
        ...mapGetters(['userInfo','token']),
        customConfig(){
            let obj = {
                uploadImgHooks: {
                    customInsert: this.customInsert
                },
                uploadImgHeaders:{
                    token: this.token
                },
                uploadImgServer: `${baseUrl}/api/file/uploadFile`
            }
            return obj
        }
    },
    watch:{
        'jsonData' :{
            handler: function (newVal) {
                if (newVal) {
                    this.$nextTick(()=>{
                        if(this.$refs.makingform){
                            if(newVal.content){
                                const { content } = newVal
                                this.formData = {
                                    name: newVal.name,
                                }
                                let newObj = JSON.parse(content)
                                newObj.list.map(item => {
                                    if(item.type == 'checkbox') item.defaultValue = item.answer.split(',')
                                    else if(item.type == 'radio') item.defaultValue = item.answer
                                })
                                this.baseUrl = baseUrl
                                this.$refs.makingform.setJSON(newObj)
                            }else{
                                this.baseUrl = baseUrl
                                this.$refs.makingform.setJSON(newVal)
                            }
                            
                        }
                    })
                } 
            }
        }
    },
    methods:{
        clearSelect () {
            this.$refs.titleTable.clearSelection()
        },
        customInsert(insertImg, result){
            console.log(1,insertImg, result)
            let data = [`${staticUrl}/${result.data.originalPath}`];
            JSON.stringify(data);
            insertImg(data);
        },
        submitTitle(){
            let timestamp =new Date().getTime()
            let obj = {}
            const json = this.$refs.makingform.getJSON()
            this.multipleSelection.map((item,index) =>{
                obj = {
                    type: "editor",
                    icon: "icon-fuwenbenkuang",
                    defaultValue: "",
                    options: {
                        "width": ""
                    },
                    name: item.title,
                    key: `${timestamp}_${index}`,
                    model: `editor_${timestamp}_${index}`,
                    rules: [],
                    score: item.score,
                    answer: item.answers || '',
                    goal: 0
                }
                json.list.push(obj)
            })
            this.$refs.makingform.setJSON(json)
            this.importOpen = false
        },
        
        handleSelectionChange(val){  //table的多选
            this.multipleSelection = val
        },
        templateNameChange(val){  //远程验证模版名字是否重复
            let params = {
                name:val,
                createUser: this.userInfo.id
            }
            duplicateCheck(params).then(res=>{
                if(res) {
                    this.$message.warning('此模版名称已被人使用，请重新输入!')
                    this.formData.name = " "
                }
            })
        },
        handleChange(val){   //级联选择器改变时
            this.tableData = []
            this.clearSelect()
            if(val.length) this.handPageChange(1)
        },
        getExpExperimentQuery(){
            const { page, limit } = this.page
            let params = {
                expUid: this.expUid[1],
                sidx: 'sort'
            }
            getExpExperimentQuery(page,limit,params).then(res=>{
                const { totalCount , list } = res
                this.tableData = list 
                this.$set(this.page,'total', totalCount)
            })
        },
        changeVisible (visible = false) {
            this.open = visible
        },
        selectExpList(){
            selectExpList().then(res => {
                this.expList = res;
            })
        },
        handPageChange(page){  //题目翻页
            this.$set(this.page, 'page', page)
            this.getExpExperimentQuery()
        },
        importSubject(){  //导入题目
            this.importOpen = true
            this.selectExpList()
        },
        handSave(){  //调用getJSon()方法拿到json数据
            let data = this.$refs.makingform.getJSON()
            data.config.name = this.formData.name
            this.$emit('handSave', data)
        },
    }
}
</script>
<style lang="scss">
.exp-temp-dialog{
    .components-list .form-edit-widget-label>a .icon{
        vertical-align: text-bottom;
    }
    .widget-view .el-checkbox__input.is-disabled + span.el-checkbox__label{
        color:#606266;
    }
    .widget-view .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
        color: #fff;
        border-color: #fff;
    }
    .is-checked .el-checkbox__input.is-disabled + span.el-checkbox__label{
        color: var(--color-primary);
    }
    .widget-view .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
        background-color: var(--color-primary);
        border-color: var(--color-primary);
    }
    .widget-view .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
        color: #fff;
        border-color: #fff;
    }
}
</style>